/* eslint-disable */
import { produce } from "immer";
import {
  MANAGE_FETCH_FAILURE,
  MANAGE_FETCH_START,
  MANAGE_FETCH_SUCCESS,
} from "../actions/types";

const manage = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case MANAGE_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case MANAGE_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case MANAGE_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default manage;
